import UsersSelection from "../helpers/UsersSelection.vue";
import { AuditUserFilter } from "./audit-filter.type";

export default defineComponent({
	name: "AuditUserFilterConfiguration",
	props: {
		filter: {
			type: Object as PropType<AuditUserFilter>,
		},
	},
	setup(props, { emit }) {
		const { t } = useI18n();

		const filter = useVModel(props, "filter", emit);

		const user = computed(() => {
			if (filter.value?.type !== "user" || !filter.value.userId) return [];

			return filter.value.userId;
		});

		function updateUser(user: string | undefined) {
			if (filter.value?.type !== "user") return;

			if (!user) {
				filter.value.userId = "";
			} else {
				filter.value.userId = user;
			}
		}

		return () => (
			<UsersSelection
				label={t("object.user")}
				users={user.value}
				onUpdate:users={updateUser}
				single
			/>
		);
	},
});
